export const PRODUCT_TYPES = {
  PIECE: 'PZ',
  KILOGRAM: 'KG',
  PIECE_KILO: 'PZKG',
};
